import { Box, SxProps, Typography } from '@mui/material';
import Introduction from './Introduction.svg';
import Checked from './Checked.svg';
import { RequestStatusEnum } from '@/types/types';

type Props = {
  requestStatus: RequestStatusEnum;
};

const baseStyle: SxProps = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '120px',
  height: '40px',
  paddingRight: '16px',
  paddingLeft: '16px',
  gap: 1,
  borderTopLeftRadius: '4px',
  borderBottomRightRadius: '12px',
  backgroundColor: '#D7F6C2',

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  zIndex: 1,
};

export function RequestStatusChip({ requestStatus }: Props) {
  return (
    <>
      {requestStatus === RequestStatusEnum.None && <></>}
      {requestStatus === RequestStatusEnum.Introduction && (
        <Box sx={baseStyle}>
          <Box
            component="img"
            src={Introduction.src}
            width={20}
            height={20}
            sx={{
              width: '20px',
              height: '20px',
            }}
          />
          <Typography
            variant="JP/Heading/s/Bold/Tight"
            sx={{
              color: '#027F00',
              fontSize: '18px',
            }}
          >
            紹介中
          </Typography>
        </Box>
      )}
      {requestStatus === RequestStatusEnum.History && (
        <Box sx={{ ...baseStyle, width: '178px', backgroundColor: '#E9E9E9' }}>
          <Box
            component="img"
            src={Checked.src}
            width={20}
            height={20}
            sx={{
              width: '20px',
              height: '20px',
              paddingTop: '2px',
            }}
          />

          <Typography
            variant="JP/Heading/s/Bold/Tight"
            sx={{
              color: '#434343',
              fontSize: '18px',
            }}
          >
            紹介履歴あり
          </Typography>
        </Box>
      )}
    </>
  );
}
